var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-hidden"},[(_vm.emailExisted)?_c('EmailExistedAlert'):_vm._e(),(_vm.accountBanned)?_c('AccountBannedAlert'):_vm._e(),_c('div',{ref:"googleAuthButton",staticClass:"btn__google-oauth"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }